import React from "react";
import { technicalSkills, softSkills } from "../../mock";
import { Code2, Users } from "lucide-react";

export default function Skills() {
  return (
    <section
      id="skills"
      className="relative py-24 md:py-32 border-t border-zinc-900 overflow-hidden"
    >
      <div className="aurora -bottom-32 -left-40 opacity-20" aria-hidden />

      <div className="relative max-w-6xl mx-auto px-6 md:px-8">
        <div className="flex items-center gap-3 mb-3 reveal">
          <span className="mono text-xs section-num font-semibold">04 //</span>
          <span className="mono text-xs text-zinc-500 uppercase tracking-[0.2em]">
            Skills
          </span>
        </div>
        <h2 className="display text-4xl md:text-5xl font-semibold reveal">
          The stack{" "}
          <span className="text-zinc-500">I work with.</span>
        </h2>

        <div className="mt-12 grid lg:grid-cols-3 gap-5" id="skills-cards">
          {/* Technical */}
          <div className="lg:col-span-2 grid sm:grid-cols-2 gap-5">
            {technicalSkills.map((g, i) => (
              <div
                key={g.name}
                className="card-hover border border-zinc-900 rounded-xl p-6 bg-[#0b0b0d] reveal"
                style={{ transitionDelay: `${i * 60}ms` }}
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <div className="h-8 w-8 rounded-md bg-[#5eead4]/10 text-[#5eead4] grid place-items-center border border-[#5eead4]/20">
                      <Code2 size={14} />
                    </div>
                    <div className="display text-base text-white">{g.name}</div>
                  </div>
                  <span className="mono text-[10px] text-zinc-600">
                    0{i + 1}
                  </span>
                </div>
                <div className="mt-5 flex flex-wrap gap-2">
                  {g.items.map((it) => (
                    <span
                      key={it}
                      className="chip mono text-xs px-2.5 py-1.5 rounded-md border border-zinc-800 text-zinc-300"
                    >
                      {it}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* Soft skills */}
          <div
            className="card-hover border border-zinc-900 rounded-xl p-6 bg-gradient-to-br from-[#0b0b0d] to-[#0b0b0d]/60 reveal"
            style={{ transitionDelay: "180ms" }}
          >
            <div className="flex items-center gap-2">
              <div className="h-8 w-8 rounded-md bg-[#a78bfa]/10 text-[#a78bfa] grid place-items-center border border-[#a78bfa]/20">
                <Users size={14} />
              </div>
              <div className="display text-base text-white">Soft Skills</div>
            </div>
            <ul className="mt-5 space-y-3">
              {softSkills.map((s, i) => (
                <li
                  key={s}
                  className="flex items-start gap-3 text-sm text-zinc-300"
                >
                  <span className="mono text-[11px] text-[#a78bfa] mt-1 shrink-0">
                    0{i + 1}.
                  </span>
                  <span>{s}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Growing list teaser */}
        <h3 className="display text-4xl md:text-5xl font-semibold reveal mt-12">
          And the list{" "}
          <span className="gradient-text">keeps growing</span>
          <span className="text-[#5eead4] cursor-blink ml-1">_</span>
        </h3>

        {/* Marquee */}
        <div className="mt-16 overflow-hidden border-y border-zinc-900 py-6 reveal">
          <div className="flex marquee-track whitespace-nowrap gap-12 mono text-zinc-600">
            {Array.from({ length: 2 }).map((_, k) => (
              <div key={k} className="flex gap-12 shrink-0">
                {[
                  "Python",
                  "Django",
                  "FastAPI",
                  "RAG",
                  "LLM",
                  "NLP",
                  "LangChain",
                  "Transformers",
                  "PowerBI",
                  "SQL",
                  "Pandas",
                  "OpenAI",
                ].map((t) => (
                  <span key={t} className="text-lg md:text-xl">
                    <span className="text-[#5eead4] mr-3">//</span>
                    {t}
                  </span>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
